import React from "react";

export const SettingContext = React.createContext();